import {
    Table, TableBody, Modal, TableCell, TableContainer, TableHead, TableRow,
    AppBar, Box, Toolbar, TextField, useTheme, IconButton, Button, Menu, MenuItem,
    ListItemText, CssBaseline,Tooltip,
} from "@mui/material";

import { useState, useEffect } from "react";
import { ExpandMore as ExpandMoreIcon, MoreVert as MoreVertIcon, Add as AddIcon, Close, } from '@mui/icons-material';

import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import AddHsnList from "./AddHsnList"; // Adjust import path if needed
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";
import { ordermanagementhelp } from "../../../data/ordermanagementhelp";
import HelpIcon from '@mui/icons-material/HelpOutline';


const HSNMaster = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const openFirst = Boolean(anchorElFirst);

    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openSecond = Boolean(anchorElSecond);

    const [newStore, setNewStore] = useState(false);
    const [storeHome, setStoreHome] = useState(true);

    const [editHSNID, setEditHSNID] = useState(0);
    const [selectedHSNData, setSelectedHSNData] = useState(null);

    const [data, setData] = useState([]);
    // const [filters, setFilters] = useState({ hsncode: '' });
    const [filters, setFilters] = useState({
  hsncode: '',
  effectivefromdate: '',
  cgstpercent: '',
  sgstpercent: '',
  igstpercent: '',
  cesspercent: '',
  acesspercent: '',
});
    const [openFilter, setOpenFilter] = useState(false);
   //const [selectedHSNData, setSelectedHSNData] = useState(null);
//help menu
const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);


    useEffect(() => {
        loadHSNList();
    }, []);

    const loadHSNList = async () => {
        let company_id = localStorage.getItem('companyid') || 1;
        const para = { p_companyid: company_id };

        try {
            const response = await callApi(API_ENDPOINTS.SALES_HSN_LIST, 'POST', { 'Content-Type': 'application/json' }, para);
            if (response && response.length > 0) {
                setData(response);
            }
        } catch (error) {
            alert(error.message);
        }
    };
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr; // fallback if invalid
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(/ /g, "-");  // 08-Sep-2025
};
    const handleShowNewHsn = () => {
    setEditHSNID(0);           // New entry (ID 0)
    setSelectedHSNData(null);  // Clear previous data
    setStoreHome(false);
    setNewStore(true);
};

const handleCallEdit = (row) => {
    setEditHSNID(row.id || 0); // Pass ID for editing
    setSelectedHSNData(row);   // Pass selected row data
    setStoreHome(false);
    setNewStore(true);
};

    const handleCallback = () => {
        setStoreHome(true);
        setNewStore(false);
        loadHSNList();
    };

    // const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     setFilters({ ...filters, [name]: value });
    // };
const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
    // const filteredData = data.filter((row) =>
    //     filters.hsncode === '' || row.hsncode.toLowerCase().includes(filters.hsncode.toLowerCase())
    // );
    const filteredData = data.filter((row) => {
  return Object.keys(filters).every((key) => {
    if (!filters[key]) return true;

    // Convert dates to DD/MM/YYYY for filtering
    const rowValue =
      key.includes("date")
        ? formatDate(row[key]) // convert to dd-Mon-yyyy
        : String(row[key] || '');

    return rowValue.toLowerCase().includes(filters[key].toLowerCase());
  });
});

    return (
        <Box>
            <CssBaseline />
            {storeHome && (
                <>
                    <AppBar position="static" sx={{ backgroundColor: "inherit", height: "48px" }}>
                        <Toolbar>
                            <Button
                                color="secondary"
                                onClick={(e) => setAnchorElFirst(e.currentTarget)}
                                endIcon={<ExpandMoreIcon sx={{ fontSize: "18px" }} />}
                                sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                            >
                                HSN Master
                            </Button>
                            <Menu anchorEl={anchorElFirst} open={openFirst} onClose={() => setAnchorElFirst(null)}>
                                <MenuItem onClick={() => setAnchorElFirst(null)}>All HSN</MenuItem>
                            </Menu>

                            <Button
              size="small"
    variant="contained"
    onClick={handleShowNewHsn}
    color="secondary"
    startIcon={<AddIcon sx={{ fontSize: "18px" }} />}
    sx={{ marginLeft: 'auto', textTransform: 'none' }}
>
    New
</Button>

                            <IconButton size="small" color="secondary" onClick={(e) => setAnchorElSecond(e.currentTarget)}>
                                <MoreVertIcon sx={{ fontSize: "18px" }} />
                            </IconButton>

                            <Menu anchorEl={anchorElSecond} open={openSecond} onClose={() => setAnchorElSecond(null)}>
                                <MenuItem onClick={loadHSNList}>
                                    <ListItemText primary="Refresh List" />
                                </MenuItem>
                            </Menu>

                             <Tooltip title="View help document details" arrow>
                                                          <IconButton
                                                            size="small"
                                                            aria-label="help"
                                                            sx={{ mx: 1 }}
                                                            onClick={handleHelpMenuClick}
                                                          >
                                                            <HelpIcon sx={{ fontSize: 18 }} />
                                                          </IconButton>
                                                        </Tooltip>
                                                        
                                                        
                                                                                <ModuleHelpDialog
                                                                                    open={helpOpen}
                                                                                    onClose={handleCloseHelp}
                                                                                    data={ordermanagementhelp.HSNMaster}
                                                                                />

                            <IconButton onClick={handleBackWinderMachineEntry}>
                                <Close sx={{ color: "#2196F3", fontSize: "18px" }} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box padding={1} sx={{
                        "& .MuiTableCell-root": {
                            border: "1px solid", borderColor: `${colors.primary[400]} !important`
                        }
                    }}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>HSN Code</TableCell>
                                        <TableCell>Effective Date</TableCell>
                                        <TableCell>CGST %</TableCell>
                                        <TableCell>SGST %</TableCell>
                                        <TableCell>IGST %</TableCell>
                                        <TableCell>Cess %</TableCell>
                                        <TableCell>ACess %</TableCell>
                                    </TableRow>
 <TableRow>
                          {Object.keys(filters).map((key) => (
                            <TableCell key={key}>
                              <TextField
                                variant="outlined"
                                size="small"
                                placeholder="Search..."
                                fullWidth
                                value={filters[key]}
                                onChange={(e) =>
                                  handleFilterChange(key, e.target.value)
                                }
                              />
                            </TableCell>
                          ))}
                        </TableRow>

                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                <span
                                                    style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                    onClick={() => handleCallEdit(row)}
                                                >
                                                    {row.hsncode}
                                                </span>
                                            </TableCell>
                                            <TableCell>{formatDate(row.effectivefromdate)}</TableCell>
                                            <TableCell>{row.cgstpercent}</TableCell>
                                            <TableCell>{row.sgstpercent}</TableCell>
                                            <TableCell>{row.igstpercent}</TableCell>
                                            <TableCell>{row.cesspercent}</TableCell>
                                            <TableCell>{row.acesspercent}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                    <Modal open={openFilter} onClose={() => setOpenFilter(false)}>
                        <Box sx={{
                            position: 'absolute', top: '50%', left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300
                        }}>
                            <TextField
                                label="HSN Code"
                                name="hsncode"
                                value={filters.hsncode}
                                onChange={handleFilterChange}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                            />
                            <Button variant="contained" onClick={() => setOpenFilter(false)} sx={{ mt: 2 }}>
                                Apply Filter
                            </Button>
                        </Box>
                    </Modal>
                </>
            )}

            {newStore && (
                <AddHsnList handlecallback={handleCallback} editStoreID={editHSNID} editData={selectedHSNData} />
            )}
        </Box>
    );
};

export default HSNMaster;
